import React from 'react';

const BancoContext = React.createContext();

export default BancoContext;
